<template>
  <div>
    <Alert v-if="topError" type="warning" show-icon>获取进程数据失败</Alert>
    <Table
      v-else-if="top.columns.length"
      border
      highlight-row
      size="small"
      :loading="loading"
      ref="topTable"
      :data="top.data"
      :columns="top.columns"
      @on-sort-change="sortChange"></Table>
    <Alert v-else show-icon>暂无数据</Alert>
  </div>
</template>

<script>
import { getContainerTop } from '@/api/container/container'

export default {
  name: 'top',
  props: {
    nodeId: true,
    containerId: true
  },
  data () {
    return {
      topError: false,
      loading: false,
      top: {
        data: [],
        columns: []
      },
      ordering: ''
    }
  },
  created: function () {
    this.getTop()
  },
  methods: {
    getTop (init = true) {
      if (init) {
        this.ordering = ''
      }
      let reqData = {
        node: this.nodeId,
        ordering: this.ordering
      }
      this.loading = true
      getContainerTop(this.containerId, reqData).then(res => {
        let result = res.data
        if (init) {
          let columns = []
          for (let i in result.title) {
            let column = {
              title: result.title[i],
              key: result.title[i],
              tooltip: true,
              sortable: 'custom'
            }
            if ((result.title.length - 1) > i) {
              column.width = 100
            }
            columns.push(column)
          }
          this.top.columns = columns
        }
        this.top.data = result.data
        this.topError = false
        this.loading = false
      }).catch(res => {
        console.log(res.response)
        this.loading = false
        this.topError = true
      })
    },
    // 排序
    sortChange (params) {
      if (params.order === 'asc') {
        this.ordering = params.key
      } else if (params.order === 'desc') {
        this.ordering = '-' + params.key
      } else {
        this.ordering = ''
      }
      this.getTop(false)
    }
  }
}
</script>

<style scoped>

</style>
